import React from 'react';
import { Link } from 'react-router-dom';
import { t } from '@sm/intl';
import COPY from './copy';
import { ROOT_PRICING_ROUTE } from '~shared/constants/pricing';

export default function IncludedLink(): React.ReactElement {
  return <Link to={`${ROOT_PRICING_ROUTE}/teams/details`}>{t(COPY.BUSINESS_PLANS_LINK)}</Link>;
}
